import * as React from "react";

type Props = {
    label: string;
};

type State = {
    label: string;
};

class Title extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { label: "Title" };
    }

    render() {
        return <h1> {this.props.label} </h1>;
    }
}

export default Title;
